<template>
  <div class="nav-bar-container">
    <img src="/static/images/name.png" alt="">
    <el-select class="nav-bar-select" v-model="value" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id">
      </el-option>
    </el-select>
    <div class="flex-1 border flex align-center">
      <img :src="user.gender === 1 ? '/static/images/boy.png' : '/static/images/girl.png'" class="avatar-img" alt="">
      <div class="font-16-30313a mr-10">{{user.name}}</div>
      <div class="font-12-85 flex-1 text-left" style="padding-top: 4px;">{{user.departmentName}}  {{user.roleName}}</div>
      <div class="flex align--center cursor" @click="toMessage">
        <img src="/static/images/xiaoxi.png" class="icon-16" alt="">
        <div class="tip-round-ff5555 mr-20" v-if="messageList.length>0">{{messageList.length}}</div>
      </div>
      <img src="/static/images/shezhi.png" @click="onChangePwd" class="icon-16 cursor ml-12" alt="">
    </div>
    <div class="pl-20">
      <div class="btn-24-bg-f5971d flex align-center" @click="toQuit">
        <img src="/static/images/tuichu.png" style="margin-right: 5px;" class="icon-16" alt="">
        <span>退出</span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'NavBar',
  components: {},
  data () {
    return {
      user: this.$store.state.user || {},
      options: [],
      value: '',
      messageList: []
    }
  },
  watch: {
    value: function (val) {
      let that = this
      this.$store.dispatch('setCompanyId', val).then(() => {
        that.$emit('on-refresh')
      })
    }
  },
  created () {
    this.axios.post(`${this.$store.state.API_URL_9010}/company/list`).then(res => {
      this.options = res.data.data
      if (!res.data.data || res.data.data.length === 0) {
        let that = this
        this.$confirm('您暂时没有所辖公司，请联系管理员设置所辖公司后重新登录！', '提示', {
          confirmButtonText: '登录',
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'error'
        }).then(() => {
          that.$store.dispatch('removeUser', {})
          that.$router.replace('/login')
        })
      } else {
        let flag = false
        this.$store.dispatch('setCompanyList', res.data.data)
        res.data.data.forEach(item => {
          if (parseInt(item.id) === parseInt(this.$store.state.companyId)) {
            if (typeof item.id === 'number') {
              this.value = parseInt(this.$store.state.companyId)
            } else {
              this.value = this.$store.state.companyId
            }
            flag = true
          }
        })
        if (!flag) {
          this.value = this.$store.state.user.companyId
        }
      }
    })
    this.getMessage()
  },
  mounted () {
  },
  methods: {
    getMessage () {
      this.messageList = []
      let param = {
        remindId: this.$store.state.user.id,
        remindType: 1,
        isRead: 0,
        status: 1
      }
      this.axios.post('message/list', param).then(res => {
        if (res.data.success) {
          this.messageList = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
      })
    },
    onChangePwd () {
      this.$emit('on-change-pwd')
    },
    toMessage () {
      // this.$store.dispatch('setNotice', 2)
      this.$parent.$refs.message.messageVisible = true
      // this.$parent.$refs.message.getMessage()
    },
    toQuit: function () {
      this.$store.dispatch('removeUser', {})
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
  .nav-bar-container {
    width: 100%;
    height: 51px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    background: url("/static/images/topbg.png") no-repeat center;
    background-size: 100% auto;
    line-height: 51px;
    display: flex;
    padding: 0 20px;
    align-items: center;
    z-index: 8;
    .border {
      border-left: 1px solid #f3f4f7;
      border-right: 1px solid #f3f4f7;
      height: 100%;
      margin-left: 20px;
      padding: 0 20px;
    }
    .avatar-img {
      width: 34px;
      height: 34px;
      border-radius: 99px;
      border: 1px solid #e5e5e5;
      margin-right: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue